import { Link } from "react-router";
import * as React from "react";
import styled, { css } from "styled-components";

interface IArrowProps {
  variant?: string;
  disabled?: boolean;
}

const ButtonLinkStyles = css<IArrowProps>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.space[3]};
  border: 0;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: 700;
  background-color: ${({ theme }) => theme.colors.yellow};
  color: ${({ theme }) => theme.colors.black};
  text-decoration: none;

  ${(props) =>
    props.variant === "secondary" &&
    css`
      background: ${({ theme }) => theme.colors.secondary};
      color: #333;
    `}
`;

export const StyledButtonLink = styled(Link)<IArrowProps>`
  ${ButtonLinkStyles}
`;

export const ButtonLinkCenter = styled.span`
  flex: 1;
  text-align: center;
`;

interface IProps {
  onClick?: () => void;
  to: string;
  children: React.ReactNode;
  variant?: string;
  disabled?: boolean;
}

type Props = IProps;

const ButtonLink: React.FC<Props> = ({
  children,
  onClick,
  to,
  variant = "primary",
  disabled = false,
}) => (
  <StyledButtonLink
    to={to}
    onClick={onClick}
    variant={variant}
    disabled={disabled}
  >
    {children}
  </StyledButtonLink>
);

export default ButtonLink;
